<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 8.29498L6.70538 13.5896C6.31581 13.9792 6.31581 14.6108 6.70538 15.0004C7.09466 15.3896 7.72569 15.39 8.11538 15.0011L12 11.125L15.8846 15.0011C16.2743 15.39 16.9053 15.3896 17.2946 15.0004C17.6842 14.6108 17.6842 13.9792 17.2946 13.5896L12 8.29498Z" fill="currentColor" />
</svg>
